<!-- =========================================================================================
File Name: ItemGridView.vue
Description: Item Component - Grid VIew
========================================================================================== -->

<template>
<div  @click="navigate_to">{{ item.code }}>
    <!-- Item Heading -->
    <div class="item-heading mb-4">
        <p class="text-lg font-semibold truncate">{{ item.designation }}</p>
        <p class="text-sm">
            <span class="mr-2">by</span>
            <span>{{ item.fournisseur }}</span>
        </p>
    </div>
    <!-- Item Image -->
    <div class="img-container w-32 mx-auto my-base" >
        <img class="responsive" :src="imgURL1" :alt="item.designation" />
    </div>
    <!-- Item Meta -->
    <div class="item-meta">
        <star-rating :show-rating="false" :rating="item.rating" :star-size="14" class="justify-center" read-only />
        <p class="text-lg font-medium text-primary">{{ item.prix.substring(0,5) }}DT</p>
    </div>
</div>
</template>

<script>
import articleServ from '@/http/requests/article/index.js'
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";
import StarRating from "vue-star-rating";
export default {
    components: {
        swiper,
        swiperSlide,
        StarRating
    },
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    watch: {
        item() {
            this.loadItemImage(this.item.code)
        }
    },
    data() {
        return {
            imgURL1: require("@/assets/images/logo/cogepha-01.png"),

        }
    },
    methods: {
        navigate_to() {
            this.$router.push({
                    name: 'item-detail-view',
                    params: {
                        item_id: this.item.code
                    }
                })
                .catch(() => {})
        },
        loadItemImage(code) {
            articleServ.getimageByCodeArticle(code).then(response => {
                if (response.data.length > 0) {
                    this.imgURL1 = 'data:image/jpeg;base64,' + response.data[0].content
                } else {
                    this.imgURL1 = require("@/assets/images/logo/cogepha-01.png")
                }
                if (this.isTheLast) {
                    this.$vs.loading.close();
                }
            }).catch(() => {
                this.imgURL1 = require("@/assets/images/logo/cogepha-01.png")
            })
        },
    },
    created() {
        this.loadItemImage(this.item.code)
    }
}
</script>

<style lang="scss" scoped>
</style>
